import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { NgOptimizedImage, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { UserAction } from '../../models/user-action';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-user-menu',
  standalone: true,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgOptimizedImage,
    UpperCasePipe,
    CdkMenuTrigger,
    CdkMenu,
    CdkMenuItem,
  ],
})
export class UserMenuComponent {
  @Input() actions: UserAction[] = [];
  @Input() userName = '';
  @Input() userImage = 'assets/account-outline.svg';
  @Output() action: EventEmitter<UserAction> = new EventEmitter();

  onAction(action: UserAction): void {
    this.action.emit(action);
  }
}
